<template>
  <div class="item pt-1">
    <template v-if="mode === 'compact'">
      <p class="black--text compact-headline" @click="toggleExpand">
        {{ item.title }}
      </p>
      <div class="block">
        <v-chip
          v-for="(attr, index) in item.attributes"
          :key="`attr-${index}`"
          class="mt-0 mb-1"
          :class="getColor(attr)"
          >{{ attr }}</v-chip
        >
      </div>

      <div v-if="expanded" class="expanded">
        <div class="mt-1 black--text expanded__description">
          {{ item.description }}
        </div>
        <div class="block mt-1">
          <ul class="list-lines-small">
            <li v-for="(sub, count) in item.items" :key="`${index}-${count}`">
              {{ sub }}
            </li>
          </ul>
        </div>
      </div>

      <div>
        <div class="icons pa-1">
          <div>
            <v-icon v-if="showControls" @click="edit(index)" class="black--text"
              >mdi-pencil</v-icon
            >
            <v-icon
              v-if="showControls && showDelete"
              @click="remove(index)"
              class="black--text ml-1"
              >mdi-delete-forever</v-icon
            >
          </div>

          <v-icon @click="toggleExpand" class="black--text"
            >mdi-arrow-expand</v-icon
          >
        </div>
      </div>
    </template>

    <template v-if="mode === 'full'">
      <div class="pa-2">
        <div class="d-flex flex-row justify-space-between align-start">
          <div>
            <h2 class="mb-2 mt-2">
              {{ item.title }}
            </h2>
            <div class="break-spaces mt-1">{{ item.description }}</div>
          </div>
          <div class="icons pa-1" v-if="showControls">
            <v-icon @click="edit(index)" class="black--text">mdi-pencil</v-icon>
            <v-icon
              @click="remove(index)"
              class="black--text"
              v-if="showControls && showDelete"
              >mdi-delete-forever</v-icon
            >
          </div>
        </div>

        <v-row>
          <v-col cols="12">
            <div class="block">
              <p class="mb-1 mt-1">
                <strong>{{ audienceLabel }}</strong>
              </p>
              <v-chip
                v-for="(attr, index) in item.audience"
                :key="`attr-${index}`"
                class="ma-1"
                :class="item.color"
                >{{ attr }}</v-chip
              >
            </div>
            <div class="block">
              <p class="mb-1 mt-1">
                <strong>{{ attributeLabel }}</strong>
              </p>
              <v-chip
                v-for="(attr, index) in item.attributes"
                :key="`attr-${index}`"
                class="ma-1"
                :class="getColor(attr)"
                >{{ attr }}</v-chip
              >
            </div>
          </v-col>
          <v-col cols="12">
            <div class="block">
              <ul class="list-lines">
                <li
                  v-for="(sub, count) in item.items"
                  :key="`${index}-${count}`"
                >
                  {{ sub }}
                </li>
              </ul>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "TimelineCard",
  data() {
    return {
      expanded: false,
    };
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },

    index: {
      type: Number,
      default: 0,
    },

    showControls: {
      type: Boolean,
      default: true,
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
    mode: {
      type: String,
      default: "full",
    },
  },
  methods: {
    edit() {
      this.$emit("edit", this.item.id);
    },
    remove() {
      this.$emit("remove", this.item.id);
    },
    toggleExpand() {
      this.expanded = !this.expanded;
    },
    getColor(title) {
      const item = this.attributes.find((x) => x.title === title);
      return item ? item.color : "";
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.list-lines {
  margin: 0;
  padding: 0;
  list-style: none;
  li {
    margin: 0;
    padding: 0.5rem 0;
    color: black;
    line-height: 1.6;
    list-style: none;
    border-bottom: 1px dotted rgba(0, 0, 0, 1);
    &:first-child {
      border-top: 1px dotted rgba(0, 0, 0, 1);
    }
    &:last-child {
      border-top: 1px dotted rgba(0, 0, 0, 0);
    }
  }
}
.compact-headline {
  font-weight: 500;
  line-height: 1.3;
  margin: 0.3rem 0 0.3rem 0;
}
.expanded {
  &__description {
    font-size: 0.8rem;
    margin-bottom: 0;
    font-weight: 500;
  }
  ul {
    margin-top: 0;
    margin-bottom: 1rem;
    li {
      font-size: 0.8rem;
      color: black;
    }
  }
}
.icons {
  display: flex;
  justify-content: space-between;
}
.item {
  height: 100%;
}
</style>
